import type * as api from '@gitbook/api-client';
import type { FileUploadMetadata, NativeFile } from '@gitbook/app-database';

export interface PendingFile {
    key: string;
    file: NativeFile;
    failed?: boolean;
    uploaded?: FileUploadMetadata;
}

export type ImportStatus =
    | 'importing'
    | 'complete'
    | 'incomplete'
    | 'error'
    | 'file-upload-limit'
    | 'file-upload-size-limit';

export type GetSpace = () => Promise<api.Space>;
export interface ImportModalProps {
    target: ImportTarget;
    getSpace: GetSpace;
    startImport: (urls: string[], space: api.Space) => void;
    importing: boolean;
    onClose: () => void;
    title?: string;
    subtitle?: string;
}

export interface OrganizationImportTarget {
    organization: string;
}

export interface SiteImportTarget extends OrganizationImportTarget {
    site: api.Site;
}

export interface SpaceImportTarget {
    space: api.Space;
    changeRequest: string | undefined;
    page: string | undefined;
}

export type ImportTarget = SiteImportTarget | OrganizationImportTarget | SpaceImportTarget;

/**
 * Returns true if the target of the import is an organization.
 */
export function isOrganizationImportTarget(
    target: ImportTarget
): target is OrganizationImportTarget {
    return 'organization' in target;
}
